import api from './api'
import ErrorService from './errorService'
import Swal from 'sweetalert2'
import Cookies from 'universal-cookie'

export const SearchService = {



  creaHubspot: async (newCliente) => {

    const cookies = new Cookies();
    try {
      const requestBody = {
        firstname: newCliente.nombre,
        lastname: newCliente.apellido,
        email: newCliente.email,
        phone: newCliente.telefono,
        rut: newCliente.rut,

      }
      const response = await ErrorService.withTimeout(api.post('/HubSpot/create', requestBody
        //,{headers:{'Authorization': `Bearer ${cookies.get('tokenGcc')}`}}
      ))

      console.log('Respuesta de HubSpot:', response.data)
      if (response.data.isSuccess == true)
        // Mostrar mensaje de éxito usando Swal
        Swal.fire({
          icon: 'success',
          title: '¡Éxito!, Espere un momento y presione nuevamente buscar',
          text: 'Espere a que el contacto sea creado en hubspot, esto puede demorar',
          confirmButtonText: 'Aceptar',
        })
      else
        Swal.fire({
          icon: 'warning',
          title: 'Problema al crear el cliente',
          text: response.data.message,
          confirmButtonText: 'Aceptar',
        })

      return response.data


    } catch (error) {
      ErrorService.handleApiError('Error en crear :', error)
      // Aquí puedes manejar el error como prefieras
      // Puedes lanzar el error nuevamente o retornar un objeto con información del error
      throw error // o return { error: error.message }
    }


  },

  searchHubspot: async (rut, email) => {
    try {
      const cookies = new Cookies();
      const response = await ErrorService.withTimeout(api.post('/HubSpot/search', { rut, email }, { headers: { 'Authorization': `Bearer ${cookies.get('tokenGcc')}` } }))
      return response.data
    } catch (error) {
      var status = error.response.status
      if (status == 401) {
        Swal.fire({
          icon: 'error',
          title: 'No autorizado',
          text: 'Usted no tiene permisos para comenzar una entrevista.',
          confirmButtonText: 'Aceptar',
        })
        return { error: 401 };
      } else
        ErrorService.handleApiError('Error en búsqueda de HubSpot:', error)
      // Aquí puedes manejar el error como prefieras
      // Puedes lanzar el error nuevamente o retornar un objeto con información del error
      throw error // o return { error: error.message }
    }
  },

  searchHubspotV2: async (data, entityType) => {
    try {
      const cookies = new Cookies();
      const response = await ErrorService.withTimeout(api.post('/HubSpot/searchV2', { data, entityType }, { headers: { 'Authorization': `Bearer ${cookies.get('tokenGcc')}` } }))
      return response.data
    } catch (error) {
      var status = error.response.status
      if (status == 401) {
        Swal.fire({
          icon: 'error',
          title: 'No autorizado',
          text: 'Usted no tiene permisos para comenzar una entrevista.',
          confirmButtonText: 'Aceptar',
        })
        return { error: 401 };
      } else
        ErrorService.handleApiError('Error en búsqueda de HubSpot:', error)
      // Aquí puedes manejar el error como prefieras
      // Puedes lanzar el error nuevamente o retornar un objeto con información del error
      throw error // o return { error: error.message }
    }
  },


  checkBaja: async (rut) => {
    try {
      const cookies = new Cookies();
      const response = await ErrorService.withTimeout(api.get('/Manager/CheckRutBaja?rut='+rut, { headers: { 'Authorization': `Bearer ${cookies.get('tokenGcc')}` } }))
      return response.data
    } catch (error) {
      var status = error.response.status
      if (status == 401) {
        Swal.fire({
          icon: 'error',
          title: 'No autorizado',
          text: 'Usted no tiene permisos para comenzar una entrevista.',
          confirmButtonText: 'Aceptar',
        })
        return { error: 401 };
      } else
        ErrorService.handleApiError('Error en búsqueda de HubSpot:', error)
      // Aquí puedes manejar el error como prefieras
      // Puedes lanzar el error nuevamente o retornar un objeto con información del error
      throw error // o return { error: error.message }
    }
  },

  searchHubspotDeal: async (negocio) => {
    try {
      const cookies = new Cookies();
      const response = await ErrorService.withTimeout(api.post('/HubSpot/searchByDeal', { negocio }, { headers: { 'Authorization': `Bearer ${cookies.get('tokenGcc')}` } }))
      return response.data
    } catch (error) {
      var status = error.response.status
      if (status == 401) {
        Swal.fire({
          icon: 'error',
          title: 'No autorizado',
          text: 'Usted no tiene permisos para comenzar una entrevista.',
          confirmButtonText: 'Aceptar',
        })
        return { error: 401 };
      } else
        ErrorService.handleApiError('Error en búsqueda de HubSpot:', error)
      // Aquí puedes manejar el error como prefieras
      // Puedes lanzar el error nuevamente o retornar un objeto con información del error
      throw error // o return { error: error.message }
    }
  },


  searchLitigantes: async (rut) => {
    try {
      // Utiliza la URL correcta con el parámetro de consulta 'rut'
      const response = await ErrorService.withTimeout(api.get(`/CausaCivil/buscar`, {
        params: { rut }
      }))

      return response.data

    } catch (error) {
      ErrorService.handleApiError(error)
    }
  },


  BusquedaCuasaPdj: async (rut) => {
    try {

      // Utiliza la URL correcta con el parámetro de consulta 'rut'
      const response = await ErrorService.withTimeout(api.get(`/CausaCivilPdj/buscar-por-rut`, {
        params: { rut }
      }))

      return response.data

    } catch (error) {
      ErrorService.handleApiError(error)
    }
  },

  BusquedaLegado: async (rut) => {
    return { legado: null }
    try {
      // Construye la URL directamente con el RUT como parte del endpoint
      const response = await ErrorService.withTimeout(
        api.get(`/Legado/ClienteEntrevista/${rut}`)
      )

      return {
        legado: response.data
      }

    } catch (error) {
      ErrorService.handleApiError(error)
      return { legado: null }
    }
  },

  // Función para buscar en la API de causas civiles
  searchCausa: async (rut) => {
    try {
      const causaResponse = await SearchService.BusquedaCuasaPdj(rut)
      // Asegúrate de que la respuesta tenga una propiedad 'results'
      return {
        demandas: causaResponse
      }
    } catch (error) {
      console.error('Error en búsqueda de Causa Litigantes:', error)
      return { demandas: null } // Manejar el error devolviendo un objeto con propiedad 'litigantes'
    }
  },

  SearchEntrevista: async (rut) => {
    try {

      // Utiliza la URL correcta con el parámetro de consulta 'rut'
      const response = await ErrorService.withTimeout(api.get(`/Entrevista/buscar`, {
        params: { rut }
      }))
      return {
        entrevista: response.data
      }
    } catch (error) {
      console.error('Error en búsqueda de Entrevista Nuevas:', error)
      return { entrevista: null } // Manejar el error devolviendo un objeto con propiedad 'litigantes'
    }
  },

  searchAll: async (rut, email, entityType) => {
    const results = {};
    try {
      let hubspotResponse;

      // Determinar qué búsqueda realizar según el entityType
      if (entityType === 'negocio') {
        hubspotResponse = await SearchService.searchHubspotDeal(rut); // Usar el rut como negocio
      } else {
        hubspotResponse = await SearchService.searchHubspot(rut, email); // Usar el rut y email
      }
      console.log('Respuesta de HubSpot:', hubspotResponse);

      if (hubspotResponse.error === 401) {
        return 401;
      }

      // Procesar resultados de HubSpot
      results.hubspot = hubspotResponse.results && hubspotResponse.results.length > 0
        ? hubspotResponse.results[0]
        : null;

      // realiza las búsquedas a partir de la respuesta de HubSpot
      var identifier = entityType === 'negocio' ? results.hubspot.properties.rut : rut;

      const [causaResponse, legadoResponse, entrevistas] = await Promise.all([
        SearchService.searchCausa(identifier),
        SearchService.BusquedaLegado(identifier),
        null // SearchService.SearchEntrevista(rut),
      ]);

      // results.demandas = causaResponse.demandas || null;
      results.legado = legadoResponse.legado || null;
      results.entrevistas = entrevistas || null;

    } catch (error) {
      console.error('Error en la búsqueda combinada:', error);
      // En caso de error, se pueden agregar detalles al objeto results o lanzar una excepción
      throw error;
    }

    return results;
  },

  searchAllV2: async (data, entityType) => {
    
    try {
      let hubspotResponse = await SearchService.searchHubspotV2(data, entityType);
      
      if (hubspotResponse.error === 401) return 401;

      if(hubspotResponse.bloqueoManager && hubspotResponse.bloqueoManager === true){
        return hubspotResponse
      }

      // Procesar resultados de HubSpot
      return (hubspotResponse.results && hubspotResponse.results.length > 0)
        ? hubspotResponse.results
        : null;
      
    } catch (error) {
      return null;
      //console.error('Error en la búsqueda de hubspot:', error);
      //En caso de error, se pueden agregar detalles al objeto results o lanzar una excepción
      //throw error;
    }
  },

  updateCustomer: async (ContactId, Rut) =>{
    try {
      const cookies = new Cookies();
      return await ErrorService.withTimeout(api.post('/HubSpot/UpdateRutContact', { ContactId, Rut }, { headers: { 'Authorization': `Bearer ${cookies.get('tokenGcc')}` } }))
    } catch (error) {
      return false
    }
  }
}


